// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__1-c3K","tableWrapperRegPrices":"Table_tableWrapperRegPrices__1hOTT","table":"Table_table__2O42h","tableRegPrices":"Table_tableRegPrices__3zgK9"};